import React, { useMemo } from 'react';
import { FieldTemplateProps } from '@rjsf/utils';
import { MarkdownContent } from '../markdown-content';
import { Templates } from '@rjsf/bootstrap-4';

export interface RawHtmlContent {
  content: string;
}

const RawHtml = ({ content }: RawHtmlContent) => {
  const scripts = [
    ...content.matchAll(/<script\b[^>]*>([\s\S]*?)<\/script\b[^>]*>/gi),
  ];
  for (const script of scripts || []) {
    try {
      window.eval(script[1]);
    } catch (error) {
      console.error(`Error running embedded script `, error);
    }
  }
  return <div dangerouslySetInnerHTML={{ __html: content }} />;
};

export function FieldTemplate({
  label,
  rawDescription,
  schema,
  ...props
}: FieldTemplateProps) {
  const rawHmtlBefore = useMemo(
    () =>
      schema?.rawHtml?.before && <RawHtml content={schema?.rawHtml?.before} />,
    [schema?.rawHtml?.before]
  );

  const rawHmtlAfter = useMemo(
    () =>
      schema?.rawHtml?.after && <RawHtml content={schema?.rawHtml?.after} />,
    [schema?.rawHtml?.after]
  );

  return (
    <>
      {rawHmtlBefore}
      {/* @ts-ignore */}
      <Templates.FieldTemplate
        schema={schema}
        {...props}
        label={
          <MarkdownContent components={{ p: 'span' }}>{label}</MarkdownContent>
        }
        rawDescription={
          rawDescription && <MarkdownContent>{rawDescription}</MarkdownContent>
        }
      />
      {rawHmtlAfter}
    </>
  );
}
